export default "__VITE_ASSET__DhiuZ425__"